import { Injectable } from '@angular/core';
import { BaseService } from '../../helpers/base.service';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AddressGateCodesService extends BaseService {

  findGateCodes(placeId: string): Observable<string> {
    const route = `${this.apiUrl}/AddressGateCodes/${placeId}`;
    return this.http.get<string>(route, this.headers()).pipe(map(response => {
      return response;
    }));
  }

}
